import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useUsuarioList } from '../../hooks/useUsuarios'
import styles from '../_shared/CrudPage.module.css'

const PERFIL_LABEL: Record<string, string> = {
  admin_tenant: 'Administrador',
  rt_mecanico: 'RT Mecânico',
  rt_qai: 'RT QAI',
  cliente: 'Cliente',
  executora: 'Técnico/Executora',
}

const PERFIL_COR: Record<string, { bg: string; color: string }> = {
  admin_tenant: { bg: '#E3F2FD', color: '#1565C0' },
  rt_mecanico: { bg: '#E8F5E9', color: '#2E7D32' },
  rt_qai: { bg: '#F3E5F5', color: '#6A1B9A' },
  cliente: { bg: '#FFF8E1', color: '#F57C00' },
  executora: { bg: '#F5F5F5', color: '#616161' },
}

export default function UsuariosListPage() {
  const [perfil, setPerfil] = useState('')
  const { data, isLoading } = useUsuarioList({
    perfil: perfil || undefined,
    page_size: 100,
  })

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Usuários</h1>
        <Link to="/usuarios/novo" className={styles.btnNovo ?? ''} data-testid="btn-usuario-novo">
          + Novo Usuário
        </Link>
      </header>

      <div className={styles.toolbar}>
        <select
          className={styles.search}
          style={{ maxWidth: 220 }}
          value={perfil}
          onChange={(e) => setPerfil(e.target.value)}
          data-testid="usuario-filtro-perfil"
          aria-label="Filtrar usuários por perfil"
        >
          <option value="">Todos os perfis</option>
          <option value="admin_tenant">Administradores</option>
          <option value="rt_mecanico">RT Mecânico</option>
          <option value="rt_qai">RT QAI</option>
          <option value="executora">Técnicos/Executora</option>
          <option value="cliente">Clientes</option>
        </select>
      </div>

      {isLoading ? (
        <div className={styles.loading}>Carregando usuários...</div>
      ) : (
        <div className={styles.grid}>
          {data?.results.map((u) => {
            const cor = PERFIL_COR[u.perfil] ?? PERFIL_COR.executora
            return (
              <Link
                key={u.id}
                to={`/usuarios/${u.id}`}
                className={styles.card}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className={styles.cardHeader}>
                  <span
                    style={{
                      fontSize: 11,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      color: 'var(--text-secondary)',
                      fontWeight: 600,
                    }}
                  >
                    Usuário
                  </span>
                  <span
                    className={styles.badge}
                    style={{ background: cor.bg, color: cor.color }}
                  >
                    {PERFIL_LABEL[u.perfil] ?? u.perfil}
                  </span>
                </div>
                <h3 className={styles.cardTitle}>{u.nome_completo}</h3>
                <p className={styles.cardSub}>📧 {u.email}</p>
                {u.registro_profissional && (
                  <p className={styles.cardSub}>📋 {u.registro_profissional}</p>
                )}
              </Link>
            )
          })}
          {data?.results.length === 0 && (
            <p className={styles.empty}>Nenhum usuário encontrado.</p>
          )}
        </div>
      )}
    </div>
  )
}
